module.exports = __webpack_public_path__ + "static/media/Effra-Regular.431f9800.woff2";